"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
var ORDERED_LIST = exports.ORDERED_LIST = /^\s*1\.\s+/;
var LIST = exports.LIST = /^\s*[\*,\-]\s+/;
var HEADING = exports.HEADING = /^\s*#+\s+/;
var BLOCKQUOTE = exports.BLOCKQUOTE = /^\s*>\s+/;

var BOLD = exports.BOLD = [/\*\*([^(?:**)]+)\*\*/g, /__([^(?:__)]+)__/g];
var ITALIC = exports.ITALIC = [/\*([^*]+)\*/g, /_([^_]+)_/g];


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/plugins/markdownSupport/markDownPatterns.js
// module id = 1737
// module chunks = 0